import React, { useState } from 'react';

import CurrencyInput from 'react-currency-input-field'

import { baseSymbol } from '../../core/currency';

const DateInput = ({ field, form, ...props }) => {
    const [ value, setValue ] = useState(field.value ? field.value / 100 : undefined)

    const inputProps = {
        ...props,
        // Store base currency symbol ('£' until multi-currency is seeded);
        // an explicit prefix prop from the caller still wins via the spread.
        prefix: props.prefix ?? baseSymbol(),
        maxLength: 9,
        step: 100,
        decimalsLimit: 2,
        onValueChange: (value) => {
          setValue(value);
        },
        onBlur: (e) => {
            field.onBlur(e);
            form.setFieldValue(
                field.name,
                value ? Math.round(value * 100) : null
            )
        }
    }

    inputProps.value = value

    return (
        <CurrencyInput
            {...inputProps}
        />
    )
}

export default DateInput
